import { formatDate, getFullName } from '@utils';

export const handlePartnersData = (data) => {
  if (!data) {
    return [];
  }

  return data?.map((item) => {
    const defaultPhoneNumber =
      item.phoneNumbers?.find((phone) => phone.isDefault) ||
      item.phoneNumbers?.[0];

    return {
      id: item.id,
      name: getFullName(item),
      firstName: item?.firstName,
      lastName: item?.lastName,
      email: item.email,
      password: item.password,
      isActive: item.isActive,
      internalId: item.internalId,
      phoneNumbers: defaultPhoneNumber ? [defaultPhoneNumber] : [],
      createdAt: item.createdAt
        ? formatDate(item.createdAt, 'dd/MM/yyyy')
        : '-',
      updatedAt: item.updatedAt
        ? formatDate(item.updatedAt, 'dd/MM/yyyy')
        : '-',
    };
  });
};
